import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  clientVersion: '1.81.0-96-g3f3fcf1b5',
  logLevel: NgxLoggerLevel.INFO,
  API_HOST: 'https://' + window.location.hostname
};
